import { render, staticRenderFns } from "./fact_id3_table.vue?vue&type=template&id=5c3553ad&scoped=true&"
import script from "./fact_id3_table.vue?vue&type=script&lang=ts&"
export * from "./fact_id3_table.vue?vue&type=script&lang=ts&"
import style0 from "./fact_id3_table.vue?vue&type=style&index=0&id=5c3553ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3553ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
